<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

@if (router.url == '/') {
  <button
    class="xrx-btn btn-secondary"
    (click)="loginOrToggle()"
    [autoClose]="'outside'"
    [ngbPopover]="homeLoginContent"
    triggers="manual"
    #homeLogin="ngbPopover"
    popoverClass="xrx-popover home-login">
    <i class="xgl-profile xglsize-24"></i>
    <span class="btn-label" [textContent]="getUserName()"></span>
  </button>
}
<ng-template #homeLoginContent>
  <div class="dropdown-item user-info" (click)="openAccountModal()">
    <i class="nul-user-glyph xgl-profile"></i>
    <div>
      <div>
        <span class="nul-user-name-label" [textContent]="getFullName()"></span>
      </div>
      <div>
        <span
          class="nul-acct-settings-label"
          [xdaTranslate]="'SDE_ACCOUNT_DETAILS'"></span>
      </div>
    </div>
  </div>
  <div role="separator" class="dropdown-divider m-0"></div>
  @if (displayHelp) {
    <div class="show-mobile">
      <span class="dropdown-item">
        <i class="xgl-help"></i>
        <span [xdaTranslate]="'SDE_HELP'"></span>
      </span>
    </div>
  }
  <div class="dropdown-item logout" (click)="logout()">
    <i class="xgl-exit"></i>
    <span [xdaTranslate]="'SDE_LOG_OUT'"></span>
  </div>
</ng-template>
@if (router.url != '/') {
  <ul class="nul-secondary-utility">
    <!-- user account -->
    <li
      class="nul-utility-item nul-utility-item-user dropdown float-left"
      [ngClass]="{ show: isExpanded }">
      <a
        class="show-desktop dropdown-toggle nul-dropdown-toggle"
        [title]="'SDE_USER' | xdaTranslate"
        role="button"
        data-dropdown="center"
        data-display="static"
        data-toggle="dropdown"
        aria-haspopup="true"
        [attr.aria-expanded]="isExpanded"
        href="#"
        (click)="loginOrToggle()">
        <span class="nul-button-label" [textContent]="getUserName()"></span
        ><i class="nul-button-glyph xgl-profile"></i>
      </a>
      <button
        class="show-mobile dropdown-toggle nul-dropdown-toggle nul-utility-btn"
        (click)="loginOrToggle()"
        data-dropdown="center"
        data-display="static"
        data-toggle="dropdown"
        aria-haspopup="true"
        [attr.aria-expanded]="isExpanded"
        [attr.aria-label]="'SDE_USER' | xdaTranslate">
        <i class="nul-button-glyph xgl-profile"></i>
      </button>
      <span class="dropdown-arrow nul-dropdown-arrow"></span>
      <ul
        class="dropdown-menu nul-dropdown-menu dropdown-menu-right"
        [ngClass]="{ show: isExpanded }">
        <li>
          <a
            class="dropdown-item nul-dropdown-item-user"
            href="#"
            (click)="openAccountModal()">
            <i class="nul-user-glyph xgl-profile"></i>
            <div>
              <div>
                <span
                  class="nul-user-name-label"
                  [textContent]="getFullName()"></span>
              </div>
              <div>
                <span
                  class="nul-acct-settings-label"
                  [xdaTranslate]="'SDE_ACCOUNT_DETAILS'"></span>
              </div>
            </div>
          </a>
        </li>
        <li role="separator" class="dropdown-divider"></li>
        @if (displayHelp) {
          <li class="show-mobile">
            <a class="dropdown-item" href="#"
              ><i class="xgl-help"></i><span [xdaTranslate]="'SDE_HELP'"></span
            ></a>
          </li>
        }
        <li>
          <a class="dropdown-item" href="#" (click)="logout()"
            ><i class="xgl-exit"></i><span [xdaTranslate]="'SDE_LOG_OUT'"></span
          ></a>
        </li>
      </ul>
    </li>
    @if (displayCredits) {
      <li class="nul-utility-item float-left">
        <a
          class="show-desktop"
          [title]="'SDE_REMAINING_CREDITS' | xdaTranslate | slice: 0 : -1"
          role="button"
          data-dropdown="center"
          data-display="static"
          (click)="showRemainingCredits()">
          <i class="nul-button-glyph xgl-coins"></i>
        </a>
        <button
          class="show-mobile nul-utility-btn"
          (click)="showRemainingCredits()"
          data-dropdown="center"
          data-display="static"
          data-toggle="dropdown"
          aria-haspopup="true"
          [attr.aria-expanded]="isExpanded"
          [attr.aria-label]="
            'SDE_REMAINING_CREDITS' | xdaTranslate | slice: 0 : -1
          ">
          <i class="nul-button-glyph xgl-coins"></i>
        </button>
      </li>
    }
    <!-- help -->
    @if (displayHelp) {
      <li class="show-desktop nul-utility-item">
        <a href="#" [title]="'SDE_HELP' | xdaTranslate"
          ><span
            class="nul-button-label sr-only"
            [xdaTranslate]="'SDE_HELP'"></span
          ><i class="nul-button-glyph xgl-help"></i
        ></a>
      </li>
    }
  </ul>
}
